<script lang="ts">
    import { account, router, saveAccount, saveRouter } from "../lib/stores";
    import { sidebarCollapsed, toggleSidebar } from "../lib/sidebar";

    let page = $router.page;
    router.subscribe((data) => (page = data.page));

    function route(path: string) {
        page = path;
        $router.page = page;
        saveRouter();
    }

    function logout() {
        account.update((data) => {
            data.isAuthorized = false;
            data.name = "";
            data.password = "";
            return data;
        });
        saveAccount();
    }
</script>

<aside
    class="fixed top-0 left-0 h-full bg-[var(--sidebar)] text-[var(--sidebar-foreground)] border-r border-[var(--sidebar-border)] flex flex-col z-50 transition-[width] duration-150 {$sidebarCollapsed
        ? 'w-14'
        : 'w-56'}"
>
    <div
        class="px-3 py-4 border-b border-[var(--sidebar-border)] flex items-center gap-2"
        class:justify-center={$sidebarCollapsed}
    >
        {#if $sidebarCollapsed}
            <div
                class="size-7 rounded bg-[var(--primary)] text-[var(--primary-foreground)] flex items-center justify-center text-xs font-bold"
                title="PIQ"
            >
                P
            </div>
        {:else}
            <div class="text-[15px] font-semibold tracking-wide px-2">
                PIQ
            </div>
        {/if}
    </div>

    <nav class="flex-1 overflow-y-auto py-3">
        {#if !$sidebarCollapsed}
            <div
                class="px-3 pb-2 text-[11px] uppercase tracking-wider text-[var(--muted-foreground)]"
            >
                Управление
            </div>
        {/if}

        <a
            href="/dashboard"
            on:click|preventDefault={() => route("/dashboard")}
            title="Устройства"
            class="mx-2 flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors
                {$sidebarCollapsed ? 'justify-center px-0' : ''}
                {page === '/dashboard' || page === '/'
                ? 'bg-[var(--sidebar-accent)] text-[var(--sidebar-accent-foreground)] font-medium'
                : 'hover:bg-[color-mix(in_oklch,var(--sidebar-accent)_60%,transparent)] text-[var(--sidebar-foreground)]'}"
        >
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="currentColor"
                class="opacity-80 shrink-0"
                ><path
                    d="M0 0h7v7H0V0zm9 0h7v7H9V0zM0 9h7v7H0V9zm9 0h7v7H9V9z"
                /></svg
            >
            {#if !$sidebarCollapsed}
                Устройства
            {/if}
        </a>

        <a
            href="/logins"
            on:click|preventDefault={() => route("/logins")}
            title="Входы"
            class="mx-2 mt-1 flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors
                {$sidebarCollapsed ? 'justify-center px-0' : ''}
                {page === '/logins'
                ? 'bg-[var(--sidebar-accent)] text-[var(--sidebar-accent-foreground)] font-medium'
                : 'hover:bg-[color-mix(in_oklch,var(--sidebar-accent)_60%,transparent)] text-[var(--sidebar-foreground)]'}"
        >
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="currentColor"
                class="opacity-80 shrink-0"
                ><path
                    fill-rule="evenodd"
                    d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z"
                /><path
                    fill-rule="evenodd"
                    d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
                /></svg
            >
            {#if !$sidebarCollapsed}
                Входы
            {/if}
        </a>
    </nav>

    {#if $account.isAuthorized}
        <div class="border-t border-[var(--sidebar-border)] p-2">
            {#if $sidebarCollapsed}
                <div class="flex flex-col items-center gap-1">
                    <div
                        class="size-8 rounded-full bg-[var(--primary)] text-[var(--primary-foreground)] flex items-center justify-center text-xs font-semibold uppercase"
                        title={$account.name}
                    >
                        {($account.name || "?").charAt(0)}
                    </div>
                    <button
                        on:click={logout}
                        title="Выход"
                        class="size-8 inline-flex items-center justify-center rounded-md text-[var(--muted-foreground)] hover:bg-[var(--sidebar-accent)] hover:text-[var(--destructive)] transition-colors cursor-pointer"
                    >
                        <svg
                            width="14"
                            height="14"
                            viewBox="0 0 16 16"
                            fill="currentColor"
                            ><path
                                fill-rule="evenodd"
                                d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"
                            /><path
                                fill-rule="evenodd"
                                d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
                            /></svg
                        >
                    </button>
                </div>
            {:else}
                <div
                    class="flex items-center gap-2 px-2 py-2 rounded-md text-sm hover:bg-[var(--sidebar-accent)] cursor-pointer group"
                >
                    <div
                        class="size-7 rounded-full bg-[var(--primary)] text-[var(--primary-foreground)] flex items-center justify-center text-xs font-semibold uppercase"
                    >
                        {($account.name || "?").charAt(0)}
                    </div>
                    <div
                        class="flex-1 truncate text-[var(--sidebar-foreground)]"
                    >
                        {$account.name}
                    </div>
                    <button
                        on:click={logout}
                        title="Выход"
                        class="opacity-60 hover:opacity-100 hover:text-[var(--destructive)] transition cursor-pointer"
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="currentColor"
                            ><path
                                fill-rule="evenodd"
                                d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"
                            /><path
                                fill-rule="evenodd"
                                d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
                            /></svg
                        >
                    </button>
                </div>
            {/if}
        </div>
    {/if}

    <button
        type="button"
        on:click={toggleSidebar}
        title={$sidebarCollapsed ? "Развернуть меню" : "Свернуть меню"}
        class="border-t border-[var(--sidebar-border)] py-3 px-3 flex items-center gap-2 text-xs text-[var(--muted-foreground)] hover:bg-[var(--sidebar-accent)] hover:text-[var(--sidebar-accent-foreground)] transition-colors cursor-pointer
            {$sidebarCollapsed ? 'justify-center' : ''}"
    >
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="shrink-0 transition-transform {$sidebarCollapsed
                ? 'rotate-180'
                : ''}"
        >
            <polyline points="11 17 6 12 11 7" />
            <polyline points="18 17 13 12 18 7" />
        </svg>
        {#if !$sidebarCollapsed}
            Свернуть
        {/if}
    </button>
</aside>
